import { SetterOrUpdater } from 'recoil';
import { annotations } from './annotations';
import { Annotation } from 'features/three-view/state/threeAtoms';

export const handleAnnotationClick = (
  title: string,
  setAnnotation: SetterOrUpdater<Annotation>
) => {
  const annotation = annotations.find(annotation => annotation.title === title);
  if (!annotation) {
    return;
  } else {
    const currentIdx = annotation.idx || 0;
    setAnnotation({ ...annotation, idx: currentIdx + 1 });
  }
};
